import { Producer } from 'types/producer'

export type ProducersOverviewProps = {
  producers: Producer[]
}

export type PromoReferralCodeForm = {
  code: string
}

export enum MobileView {
  MAP = 'Map',
  LIST = 'List'
}
